module.exports = __webpack_public_path__ + "static/media/AccountsScreen.667ae762.svg";